"use strict";
import { ApolloClient, ApolloLink, InMemoryCache, Observable } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";
const httpLink = new ApolloLink(() => {
  return new Observable((observer) => {
    observer.next({ data: {} });
    observer.complete();
  });
});
const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        nftBalances: relayStylePagination(["ownerAddress", "filter"]),
        nftAssets: relayStylePagination(),
        nftActivity: relayStylePagination(),
        tokenProjects: relayStylePagination(),
        token: {
          // Tokens should be cached by their chain/address, *not* by the ID returned by the server.
          // This is because the ID may change depending on fields requested.
          read(_, { args, toReference }) {
            return toReference({ __typename: "Token", chain: args?.chain, address: args?.address?.toLowerCase() });
          }
        }
      }
    },
    Token: {
      // Tokens are cached by their chain/address (see Query.fields.token, above).
      // In any query for `token` or `tokens`, you *must* include `chain` and `address` fields in order
      // to properly normalize the result in the cache.
      keyFields: ["chain", "address"],
      fields: {
        address: {
          // Always cache lowercased for consistency (backend sometimes returns checksummed).
          read(address) {
            return address?.toLowerCase() ?? null;
          }
        }
      }
    },
    TokenProject: {
      fields: {
        tokens: {
          // Cache data may be lost when replacing the tokens array, so retain all known tokens.
          merge(existing, incoming, { toReference }) {
            if (!existing || !incoming) {
              return existing ?? incoming;
            } else {
              const refs = existing.map((token) => toReference(token, true));
              const refSet = refs.reduce((refSet2, ref) => refSet2.add(ref.__ref), /* @__PURE__ */ new Set());
              const newRefs = incoming.map((token) => toReference(token, true)).filter((ref) => !refSet.has(ref.__ref));
              return [...refs, ...newRefs];
            }
          }
        }
      }
    },
    TokenMarket: {
      keyFields: ["id"]
    }
  }
});
export const apolloClient = new ApolloClient({
  link: httpLink,
  cache
});
